import { COLORS } from "./colors";
import {
  HouseIcon,
  CondoIcon,
  TownhomeIcon,
  MobileHomeIcon,
  MultiplexIcon,
  ApartmentIcon,
  AcreageIcon,
  TwinIcon,
  RecreationalIcon,
  OtherPropertyIcon,
} from "src/components/icons";

export const LISTING_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  CANCELED: 'canceled',
  WITHDRAWN: 'withdrawn',
  LIS_PENDENS: 'lis pendens',
  NOTICE_OF_DEFAULT: 'notice of default',
  FSBO: 'fsbo',
  NOTICE_OF_TRUSTEE_SALE: 'notice of trustee sale',
  NOTICE_OF_SALE: 'notice of sale',
  PENDING: 'pending',
  SOLD: 'sold',
  OFF_MARKET: 'off market',
  UNKNOWN: 'unknown',
  BANK_OWNED: 'bank owned'
} as const;

export const LISTING_STATUS_COLORS = {
  ACTIVE: {
    color: "red",
    text: COLORS.DANGER,
    background: COLORS.DANGER_LIGHT
  },
  GREEN: {
    color: "green",
    text: COLORS.SUCCESS,
    background: COLORS.SUCCESS_LIGHT
  },
  ORANGE: {
    color: "orange",
    text: COLORS.WARNING,
    background: COLORS.WARNING_LIGHT
  },
  BANK_OWNED: {
    color: "gray",
    text: COLORS.GRAY_PRIMARY,
    background: "#ECEFEF"
  },
  DEFAULT: {
    color: "transparent",
    text: "transparent",
    background: "transparent"
  }
} as const;

export const SUPPORTED_SOCIAL_MEDIA = [
  "facebook",
  "twitter",
  "linkedin",
  "instagram",
] as const;

export const FALLBACK_MAP_MARKER_COLOR = COLORS.PRIMARY;
export const SELECTED_LISTING_MAP_MARKER_COLOR = COLORS.SELECTED;

// Property type codes for Expireds (from legacy PropertyTypeEnum)
export const EXPIRED_PROPERTY_TYPES = {
  singleFamily: "S",
  home: "H",
  condo: "C",
  twin: "W",
  townhouse: "T",
  mobile: "M",
  recreational: "R",
  acreage: "G",
  apartment: "A",
  other: "O",
  multiplex: "X",
} as const;

export const EXPIRED_PROPERTY_TYPE_OPTIONS = [
  { value: EXPIRED_PROPERTY_TYPES.singleFamily, label: "Single Family", icon: <HouseIcon /> },
  { value: EXPIRED_PROPERTY_TYPES.condo, label: "Condo", icon: <CondoIcon /> },
  { value: EXPIRED_PROPERTY_TYPES.townhouse, label: "Townhouse", icon: <TownhomeIcon /> },
  { value: EXPIRED_PROPERTY_TYPES.mobile, label: "Mobile", icon: <MobileHomeIcon /> },
  { value: EXPIRED_PROPERTY_TYPES.multiplex, label: "Multiplex", icon: <MultiplexIcon /> },
  { value: EXPIRED_PROPERTY_TYPES.apartment, label: "Apartment", icon: <ApartmentIcon /> },
  { value: EXPIRED_PROPERTY_TYPES.acreage, label: "Acreage", icon: <AcreageIcon /> },
  { value: EXPIRED_PROPERTY_TYPES.twin, label: "Twin", icon: <TwinIcon /> },
  { value: EXPIRED_PROPERTY_TYPES.recreational, label: "Recreational", icon: <RecreationalIcon /> },
  { value: EXPIRED_PROPERTY_TYPES.home, label: "Home", icon: <HouseIcon /> },
  { value: EXPIRED_PROPERTY_TYPES.other, label: "Other", icon: <OtherPropertyIcon /> },
];

export const DEFAULT_EXPIRED_PROPERTY_TYPES = [
  EXPIRED_PROPERTY_TYPES.singleFamily,
  EXPIRED_PROPERTY_TYPES.condo,
  EXPIRED_PROPERTY_TYPES.townhouse,
  EXPIRED_PROPERTY_TYPES.multiplex,
  EXPIRED_PROPERTY_TYPES.home,
];

export const SUGGESTED_TAG_GROUPS = [
  {
    name: 'communication',
    tags: [
      "Attempt1",
      "Attempt2",
      "Attempt3",
      "Attempt4",
      "Attempt5",
      "Attempt6",
      "Attempt7",
      "Attempt8",
      "VM1",
      "VM2",
      "VM3",
      "VM4",
      "VM5",
      "Email1",
      "Email2",
      "Email3",
      "CardSent1",
      "CardSent2",
      "CardSent3",
    ]
  },
  {
    name: 'funnel',
    tags: [
      "New",
      "Contacted",
      "SetAppt",
      "ListingAppt",
      "Listed",
      "Sold",
      "NotInterested",
      "WrongNumber",
      "CallBack",
      "FollowUp",
    ]
  }
] as const; 